import { Position } from './position.model';

export class MarkerClusterRedraw {

    public featureId: number;
    public position?: Position;

    constructor(obj: Partial<MarkerClusterRedraw>) {
        Object.assign(this, obj);
    }

}
